import type { ReactNode } from "react";

// Der Hinweis über einer Seite, die man nur ansehen darf. Match und Projekt zeigen ihn gleich (spark#1001).
export function ReadOnlyBanner({ id, children }: { id: string; children: ReactNode }) {
  return (
    <div id={id} role="status" className="mt-4 rounded-md bg-ink/[0.06] px-4 py-2 text-smycles-body text-ink">
      {children}
    </div>
  );
}
